export function normalizeUserInput(raw: string): string {
  return raw.trim().toLowerCase();
}
export function stripHyphens(s: string): string {
  return s.replace(/-/g, '');
}
export function yoToE(s: string): string {
  return s.replace(/ё/g, 'е');
}
